<app-window [title]="title" >
     <div class="row mb-3" *ngIf="record.id==0 || record.id==undefined">
        <div class="col-12">
            <i class="float-left h-100 pr-2 text-warning fas fa-exclamation-triangle fa-2x"></i>
            <div class="">
                <small>
                    <b>NOTA BENE:</b>
                    <div>
                        <span>Salva il record per poter definire i <b>permessi</b> sui moduli. Fai aggiungere il nome del ruolo nel file <b>config.json</b></span>
                    </div>
                </small>
            </div>
        </div>
    </div>
    <form role="form" id="detailForm">       
        <div class="row">           
            <div class="col-lg-6">
                <div class="form-group form-group-sm mb-1">
                    <label>Nome</label>
                    <input type="text" class="form-control form-control-sm" placeholder="..." name="name"  [(ngModel)]="record.name" >
                </div>
            </div>
             <div class="col-lg-6">
                <div class="form-group form-group-sm mb-1">
                    <label>Etichetta</label>
                    <input type="text" class="form-control form-control-sm" placeholder="..." name="title"  [(ngModel)]="record.title" >
                </div>
            </div>
            <div class="col-lg-12">
                <div class="form-group form-group-sm">
                    <label>Descrizione</label>
                    <input type="text" class="form-control form-control-sm" placeholder="..." name="description"  [(ngModel)]="record.description" >
                </div>
            </div>
        </div>
        <div class="row" *ngIf="record.id!=0 && record.id!=undefined">
            <div class="col-12">
                <h5>Gestione permessi sui moduli</h5>
                <table class="table table-sm">
                    <ng-container *ngFor="let m of record.permissions">
                        <tr class="bg-light">
                            <td>
                                <b>{{m.label}}</b>
                                <b><app-selecttables [value]="m.modulename" [no_select]="true"></app-selecttables></b>
                            </td>
                            <td class="text-right">
                                <button class="btn btn-xs btn-block btn-default" title="Tutti" (click)="checkAll(m.modulename)">inverti selezione</button>
                            </td>
                        </tr>
                        <tr *ngFor="let p of m.permissions">
                            <td>
                                <small>{{p.description}}&emsp;<i class="text-primary">({{p.name}})</i></small>                                
                            </td>
                            <td class="text-right">
                                <div class="btn-group btn-group-sm w-100">
                                    <button [class.alert-success]="p.value==true" type="button" class="btn btn-default border btn-sm" (click)="p.value=true">Sì</button>
                                    <button [class.alert-danger]="p.value==false" type="button" class="btn btn-default border btn-sm" (click)="p.value=false">No</button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </div>
        </div>
    </form>
    <app-toolbarmodel [model]="this" [showSaveAndClose]="true"></app-toolbarmodel>
</app-window>